import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import styles from "./CategoriesSlider.module.scss";
import { useTranslation } from "react-i18next";
import ProductsService from "../../../../api/services/products.service";
import { useLanguage } from "../../../../context/LanguageContext";
import LocalizedLink from "../../../common/localized-link/LocalizedLink";

interface CategoryChild {
  children: CategoryChild[];
  id: number;
  image: string;
  name: string;
  name_az?: string;
  name_en?: string;
  name_es?: string;
  name_de?: string;
  parent_id: number | null;
}

interface CategoriesTypes {
  children: CategoryChild[];
  id: number;
  image: string;
  name: string;
  name_az?: string;
  name_en?: string;
  name_es?: string;
  name_de?: string;
  parent_id: number | null;
}

const CategoriesSlider = () => {
  const [categories, setCategories] = useState<CategoriesTypes[]>([]);
  const { t } = useTranslation("translation");
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    const getData = async () => {
      const res = await ProductsService.getCategories();
      setCategories(res.data);
    };
    getData();
  }, []);

  const getLocalizedCategoryName = (category: CategoriesTypes) => {
    if (!category) return "";

    switch (currentLanguage) {
      case "az":
        return category.name_az || category.name;
      case "en":
        return category.name_en || category.name;
      case "es":
        return category.name_es || category.name;
      case "de":
        return category.name_de || category.name;
      default:
        return category.name;
    }
  };

  return (
    <section className={styles.categories_section}>
      <div className="container">
        <h2 className={styles.title}>{t("categories") || "Kateqoriyalar"}</h2>
        <div className={styles.slider_wrapper}>
          <Swiper
            modules={[Autoplay]}
            loop={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            speed={3000}
            spaceBetween={16}
            slidesPerView="auto"
            className={styles.categories_slider}
            breakpoints={{
              0: { spaceBetween: 10 },
              480: { spaceBetween: 12 },
              768: { spaceBetween: 14 },
              1024: { spaceBetween: 16 },
            }}
          >
            {categories.map((cat) => (
              <SwiperSlide key={cat.id} className={styles.category_slide}>
                <LocalizedLink
                  to={`/products/${cat.id}`}
                  className={styles.category_card}
                >
                  <h3 className={styles.category_name}>
                    {getLocalizedCategoryName(cat)}
                  </h3>
                </LocalizedLink>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default CategoriesSlider;
